import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eDotTaoDeActionIds,
  IDotTaoDeActionTypes,
} from "../../action-types/de-thi/IDotTaoDeActions";
import { dotTaoDeApi } from "../../../api/de-thi/dotTaoDeApi";
import { ISMT_DotTaoDe_Request } from "../../../model/request/de-thi/ISMT_DotTaoDe_Request";
import { ISMT_DotTaoDe } from "../../../model/respone/de-thi/ISMT_DotTaoDe";
import { v4 as uuidv4 } from "uuid";
import { IProcessRequest } from "../../../model/request/IProcessRequest";

export function* dotTaoDeSaga(): any {
  yield takeLatest(eDotTaoDeActionIds.LOAD_START, loadWorker);
  yield takeLatest(eDotTaoDeActionIds.DELETE_START, deleteWorker);
  yield takeLatest(
    eDotTaoDeActionIds.DELETE_MULTIPLE_START,
    deleteMultipleWorker
  );
  yield takeLatest(eDotTaoDeActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDotTaoDeActionIds.CREATE_DETHI_START, createDeThiWorker);
}

function* loadWorker(action: IDotTaoDeActionTypes): any {
  const res: IBaseRespone = yield call(
    dotTaoDeApi.Select,
    action.payload as ISMT_DotTaoDe_Request
  );
  if (res.is_success) {
    yield put(rootActions.deThi.dotTaoDe.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.dotTaoDe.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDotTaoDeActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_DotTaoDe;
  if (payload.id > 0) {
    res = yield call(dotTaoDeApi.Update, payload);
  } else {
    res = yield call(dotTaoDeApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.dotTaoDe.SAVE_SUCCESS(res.data));
      if (!payload.id && !payload.is_tudongtaode) {
        const process_id = uuidv4();
        yield put(
          rootActions.deThi.dotTaoDe.CREATE_DETHI_START({
            payload: res.data.id,
            process_id,
          })
        );
      }
    } else {
      yield put(rootActions.deThi.dotTaoDe.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* deleteWorker(action: IDotTaoDeActionTypes): any {
  const res: IBaseRespone = yield call(
    dotTaoDeApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.dotTaoDe.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.dotTaoDe.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* deleteMultipleWorker(action: IDotTaoDeActionTypes): any {
  const res: IBaseRespone = yield call(
    dotTaoDeApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(rootActions.deThi.dotTaoDe.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.dotTaoDe.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* createDeThiWorker(action: IDotTaoDeActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IProcessRequest<number>;
  res = yield call(dotTaoDeApi.CreateDeThiAsync, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.dotTaoDe.CREATE_DETHI_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.deThi.dotTaoDe.CREATE_DETHI_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}
